var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"breadcrumb"},[_c('router-link',{attrs:{"to":_vm.route}},[_c('i',{staticClass:"icon-ic_arrow_left_blue"}),_c('h6',[_vm._v(_vm._s(_vm.title))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }